$( document ).ready(function() {
    // VARIABLES
    var windowWidth = $(window).outerWidth();
    var headerHeight = $('#header').outerHeight();
    var oldheaderPadding = $('.header-main-wrap').css('padding');

	// FUNCTIONS
	$('a[data-rel^=lightcase]').lightcase({ showSequenceInfo: false });

	// WINDOW ON LOAD
	$(window).on("load", function(){
		caroufredsel_slider();
    fixHeader(headerHeight);
    if(windowWidth >= 992){
        stickSidebar(windowWidth);
    }
	  // LOADER
    $(window).resize();
    setTimeout(function(){
      $('.spinner-wrap').css({'opacity': '0'});
      $('.spinner-wrap').hide();
    },500);
	});

	// WINDOW ON RESIZE with Timer for better usage
	$(window).on('resize', function(e){
    	caroufredsel_slider();

      clearTimeout(window.resizedFinished);
      window.resizedFinished = setTimeout(function(){
          hero_slider.trigger('refresh.owl.carousel');
          var windowWidth = $(window).outerWidth();

          // $('.contact-info').slideDown(300);
          // $('.header-main-wrap').css({'padding': oldheaderPadding, 'transition': '.3s'});
          if(windowWidth >= 576){
              services_slider();
          }else{
            $('.service-slider .slides').trigger('destroy');
          }

          if(windowWidth >= 992){
              stickSidebar(windowWidth);
          }else{
              $('.sidebar').trigger('sticky_kit:detach');
          }

          setTimeout(function(){
              var headerHeight = $('#header').outerHeight();
              fixHeader(headerHeight);
          },600);

      }, 350);
  	});

  	// IOS INPUT BUG FIX
    (function iOS_CaretBug() {
       var ua = navigator.userAgent,
       scrollTopPosition,
       iOS = /iPad|iPhone|iPod/.test(ua),
       iOS11 = /OS 9|OS 10|OS 11_0|OS 11_1|OS 11_2/.test(ua);

       // ios 11 bug caret position
       if ( iOS && iOS11 ) {

           $(document.body).on('show.bs.modal', function(e) {
               if ( $(e.target).hasClass('modal') ) {
                   // Get scroll position before moving top
                   scrollTopPosition = $(document).scrollTop();

                   // Add CSS to body "position: fixed"
                   $("body").addClass("iosBugFixCaret");
               }
           });

           $(document.body).on('hide.bs.modal', function(e) {
               if ( $(e.target).hasClass('modal') ) {
                   // Remove CSS to body "position: fixed"
                   $("body").removeClass("iosBugFixCaret");

                   //Go back to initial position in document
                   $(document).scrollTop(scrollTopPosition);
               }
           });
       }
    })();

    // Mobile Sidebar
    $('#sidemobCollapse').on('click', function () {
      $btnCollapse = $(this);
      $('#sidemob').addClass('active');
      if($('#sidemob').hasClass('active')){
        setTimeout(function() { $btnCollapse.find('i').removeClass('fa-bars').addClass('fa-arrow-right'); $btnCollapse.addClass('active'); }, 50);
        $("body").css("overflow", "hidden");
      }else{
        $("body").css("overflow", "visible");
      }
      $('.sidemob-overlay').fadeIn(200);
      $('.collapse.in').toggleClass('in');
      // $('a[aria-expanded=true]').attr('aria-expanded', 'false');
    });
    $('#dismiss, .sidemob-overlay').on('click', function () {
      setTimeout(function() {  $('#sidemobCollapse').find('i').removeClass('fa-arrow-right').addClass('fa-bars');  $('#sidemobCollapse').removeClass('active'); }, 50);
      $('#sidemob').removeClass('active');
      if($('#sidemob').hasClass('active')){
        $("body").css("overflow", "hidden");
      }else{
        $("body").css("overflow", "visible");
      }
      $('.sidemob-overlay').fadeOut(200);
    });
    $('#sidemobCollapse').on('click', function(){
      if($(this).hasClass('active'))
        $('#dismiss').click();
    });

    // Navigation Dropdown
    $('ul.nav-links li.dropdown').hover( function() {
        $(this).find('.dropdown-menu').eq(0).stop(true, true).delay(200).slideDown(200);
    }, function() {
        $(this).find('.dropdown-menu').eq(0).stop(true, true).delay(200).slideUp(200);
    });

    // Serach Overlay
    $('.search-now').on('click', function(e){
      e.preventDefault();
      $('.search-overlay').fadeIn('300');
    });
    $('.search-close, #content, #footer').on('click', function(){
      $('.search-overlay').fadeOut('300');
    });

    // Owl carousel
    // Hero Slider
    var hero_slider = $('#hero .hero-slider-wrap .hero-slider');
    var $hero_autoplay = hero_slider.data('autoplay');
    var $hero_timeout = parseInt(hero_slider.data('timeout'));
    var $hero_hover = hero_slider.data('hover');
    hero_slider.owlCarousel({
      animateOut:'fadeOut',
      autoplay:$hero_autoplay,
      autoplayTimeout:$hero_timeout,
      autoplayHoverPause:$hero_hover,
      loop:false,
      responsiveClass:true,
      responsiveRefreshRate:700,
      rewind:true,
      nav:false,
      dots:true,
      responsive:{
          0:{ autoHeight:true,autoWidth:false,items:1,center:true,margin:0 }
      }
    });
    // Gallery Widget Slider
    var t_slider = $('#testi .owl-carousel');
    var $t_autoplay = t_slider.data('autoplay');
    var $t_timeout = parseInt(t_slider.data('timeout'));
    var $t_hover = t_slider.data('hover');
    t_slider.owlCarousel({
      // animateOut:'fadeOut',
      autoplay:$t_autoplay,
      autoplayTimeout:$t_timeout,
      autoplayHoverPause:$t_hover,
      responsiveClass:true,
      responsiveRefreshRate:50,
      nav:false,
      dots:true,
      dotsEach:true,
      responsive:{
          0:{ loop:$('#testi .owl-carousel li').size() > 1 ? true:false,autoHeight:true,autoWidth:false,items:1,center:false,margin:0,nav:false }
      }
    });

    // Scroll to Top
    var pxScrolled = 200;
    var duration = 500;
    $(window).scroll(function() {

        // For BTT
        if ($(this).scrollTop() > pxScrolled) {
            $('.fab-container').css({'bottom': '0px', 'transition': '.3s'});
        } else {
            $('.fab').off('mouseenter mouseleave');
            $('.fab-container').css({'bottom': '-82px'});
        }

    });

    $('.goTop').on('click', function() {
        $('html, body').animate({scrollTop: '0px'}, duration);
        $('.fab').off('mouseenter mouseleave');
    })

    // CAROUFREDSEL SLIDER
  	function caroufredsel_slider() {
  		$(".cs-slider .slides").each(function(){
  			var $this    = $(this);
  			var ctrlPrev = $(this).closest(".cs-slider").find(".prev");
  			var ctrlNext = $(this).closest(".cs-slider").find(".next");

  			$this.carouFredSel({
  				auto: {
  					play: $this.data("auto"),
  					timeoutDuration: $this.data("duration"),
  				},
  				start      : "random",
  				width      : $this.data("cs-width"),
  				circular   : $this.data("cs-circular"),
  				infinite   : $this.data("cs-infinite"),
  				height     : $this.data("cs-height"),
  				responsive : $this.data("cs-responsive"),
  				direction  : $this.data("cs-direction"),
  				prev       : ctrlPrev,
  				next       : ctrlNext,
  				pagination : "."+$this.data("paginate"),
  				scroll:{
  					items: $this.data("item-scroll"),
  					fx   : $this.data("effects"),
  				},
  				items:{
  				  height : $this.data("item-height"),
  				  width  : $this.data("item-width"),
  				  visible: {
  				    	min: $this.data("min"),
  				    	max: $this.data("max")
  				  },
  				},
  				swipe:true,
  			});

  			$this.touchwipe({
  				wipeUp: function(e) {
  				 	e.preventDefault();
  				},
  				wipeDown: function(e) {
  				 	e.preventDefault();
  				},
  				wipeLeft: function(e) {
  				 	$this.trigger("next", 1);
  				},
  				wipeRight: function(e) {
  				 	$this.trigger("prev", 1);
  				}
  			});
  		});
  	}
    function services_slider() {
      $(".service-slider .slides").each(function(){
        var $this    = $(this);
        var ctrlPrev = $(this).closest(".service-slider").find(".prev");
        var ctrlNext = $(this).closest(".service-slider").find(".next");

        $this.carouFredSel({
          auto: {
            play: $this.data("auto"),
            timeoutDuration: $this.data("duration"),
          },
          start      : "random",
          width      : $this.data("cs-width"),
          circular   : $this.data("cs-circular"),
          infinite   : $this.data("cs-infinite"),
          height     : $this.data("cs-height"),
          responsive : $this.data("cs-responsive"),
          direction  : $this.data("cs-direction"),
          prev       : ctrlPrev,
          next       : ctrlNext,
          pagination : "."+$this.data("paginate"),
          scroll:{
            items: $this.data("item-scroll"),
            fx   : $this.data("effects"),
          },
          items:{
            height : $this.data("item-height"),
            width  : $this.data("item-width"),
            visible: {
                min: $this.data("min"),
                max: $this.data("max")
            },
          },
          swipe:true,
        });

        $this.touchwipe({
          wipeUp: function(e) {
            e.preventDefault();
          },
          wipeDown: function(e) {
            e.preventDefault();
          },
          wipeLeft: function(e) {
            $this.trigger("next", 1);
          },
          wipeRight: function(e) {
            $this.trigger("prev", 1);
          }
        });
      });
    }

    // Fix Image and Link Margin inside p
    $('.hero-content p:has(a), #about .about-content p:has(img), #about .about-content p:has(a), #twocol .col-content p:has(a), .team-card .member-info p:has(a)').css('margin', '0');
    $('.nav-links > li:has(span)').css('margin-right', '10px');

    if($('#map').length){
      google.maps.event.addDomListener(window, "load", initMap);
    }

});

function fixHeader(h){
    var headerHeight = $('#header').outerHeight();
    $('#content').css({'margin-top': h - 2,'transition': 'all .5s ease'});
}

function stickSidebar(ww){
    // Get offset_top
    var $offset = 0;
    if(ww >= 992 && ww <= 1199){
      $offset = 105;
    }else if(ww >= 1200 && ww <= 1399){
      $offset = 130;
    }else if(ww >= 1400){
      $offset = 150;
    }
    // Stick Sidebar
    $(".sidebar").stick_in_parent({ offset_top: $offset });
}

function initMap() {
    // Custom map style pink mode.
    // Default value for lat and lang are : -33.86898610271999 and 151.20943900000007
    // The above is for backup purposes only. Thank you.
    var $lat = parseFloat($('#map').data('lat'));
    var $lng = parseFloat($('#map').data('lng'));
    var map = new google.maps.Map(document.getElementById('map'), {
      center: {lat: $lat, lng: $lng},
      zoom: 16,
      // zoomControl: true, Will be enabled incase requested
    });

    var marker = new google.maps.Marker({
      position: {lat: $lat, lng: $lng},
      map: map,
      title: $('#map').data('title'),
      icon: $('#map').data('map-icon')
    });
}